import { NotificationValueTaskDeleted } from '@lib/types/notification'
import { TFunction } from '@translations/useTranslations'
import { formatDate, TimeStamp } from '@utils/Date'
import { isSubTask, isToDo } from '@utils/Task'
import {
  formatNotificationSubtitute,
  NOTIFICATION_ACTIONS,
  parseNotificationText,
} from './utils'

export const taskNotifications = (t: TFunction) => ({
  [NOTIFICATION_ACTIONS.NEW_TASK]: (data: any) => (
    <>
      {isToDo(data.task) ? t('commentLogs.newToDo') : t('commentLogs.newTask')}{' '}
      <span className="font-semibold">{`"${parseNotificationText(
        data.task?.name,
        70,
      )}"`}</span>{' '}
      {t('expressions.hasBeenAssignedToYou')}
    </>
  ),

  [NOTIFICATION_ACTIONS.DELETED_TASK]: (data: any) => (
    <>
      {isToDo(data.task) ? t('commentLogs.toDo') : t('commentLogs.task')}{' '}
      <span className="font-semibold">{`"${parseNotificationText(
        (data.snapshot as NotificationValueTaskDeleted)?.taskName,
        70,
      )}"`}</span>{' '}
      {t('commentLogs.hasBeenDeleted')}
    </>
  ),

  [NOTIFICATION_ACTIONS.OWNER_CHANGED]: (data: any) => (
    <>
      {isToDo(data.task)
        ? t('commentLogs.theOwnerOfToDo')
        : t('commentLogs.theOwnerOfTask')}{' '}
      <span className="font-semibold">{`"${parseNotificationText(
        data.task?.name,
      )}"`}</span>{' '}
      {formatNotificationSubtitute(data, t)}
    </>
  ),
  [NOTIFICATION_ACTIONS.DEADLINE_CHANGED]: (data: any) => (
    <>
      {isToDo(data.task)
        ? t('commentLogs.deadlineOfToDo')
        : t('commentLogs.deadlineOfTask')}{' '}
      <span className="font-semibold">{`"${parseNotificationText(
        data.task?.name,
      )}"`}</span>{' '}
      {t('commentLogs.hasBeenChangedTo')}{' '}
      {formatDate(data.snapshot as TimeStamp, true)}{' '}
      {data.previousValue !== null ? (
        <>
          ({t('commentLogs.previousDeadline')}:{' '}
          {formatDate(data.previousValue as TimeStamp, true)})
        </>
      ) : (
        ''
      )}
    </>
  ),

  [NOTIFICATION_ACTIONS.DONE_TASK]: (data: any) => (
    <>
      {isToDo(data.task)
        ? t('commentLogs.toDo')
        : isSubTask(data.task)
          ? t('commentLogs.subTask')
          : t('commentLogs.task')}{' '}
      <span className="font-semibold">{`"${parseNotificationText(
        data.task?.name,
        70,
      )}"`}</span>{' '}
      {t('commentLogs.hasBeen')} {t('commentLogs.done')}
    </>
  ),

  [NOTIFICATION_ACTIONS.CANCELED_TASK]: (data: any) => (
    <>
      {isToDo(data.task)
        ? t('commentLogs.toDo')
        : isSubTask(data.task)
          ? t('commentLogs.subTask')
          : t('commentLogs.task')}{' '}
      <span className="font-semibold">{`"${parseNotificationText(
        data.task?.name,
        70,
      )}"`}</span>{' '}
      {t('commentLogs.hasBeen')} {t('commentLogs.cancelled')}
    </>
  ),

  [NOTIFICATION_ACTIONS.ASSIGNEE_CHANGED]: (data: any) => {
    return (
      <>
        {isToDo(data.task)
          ? t('commentLogs.theAssigneeOfToDo')
          : t('commentLogs.theAssigneeOfTask')}{' '}
        <span className="font-semibold">{`"${parseNotificationText(
          data.task?.name,
        )}"`}</span>{' '}
        {formatNotificationSubtitute(data, t)}
      </>
    )
  },

  [NOTIFICATION_ACTIONS.FOLLOWERS_CHANGED]: (data: any) => {
    return (
      <>
        {t('commentLogs.addedAsFollower')}{' '}
        {isToDo(data.task) ? t('commentLogs.toDo') : t('commentLogs.task')}{' '}
        <span className="font-semibold">{`"${parseNotificationText(
          data.task?.name,
        )}"`}</span>
      </>
    )
  },
})
